var render = function render(){var _vm=this,_c=_vm._self._c;return _c('CommonEstimateDetail',{attrs:{"basic-info":_vm.basicInfo,"history-insert-type":"bill"}})
}
var staticRenderFns = []

export { render, staticRenderFns }